import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { CardTypes } from 'src/app/enums/Audit/cardType.enum';
import { CategoryNames } from 'src/app/enums/Audit/categoryNames.enum';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';
import { StageReviewDetail } from './models/stage-review.model';
import { ProjectDetailConstant } from './project-detail.constant';
import { AuditSharedService } from 'src/app/services/Audit/audit-shared.service';
import { SubCategoryModel, SubCategoryModelGroup } from './models/subcategory.model';
import { CategoryModel } from './models/category.model';
import { AuditSummaryFormModel } from './models/audit-summary.model';
import { RiskRegisterFormModel } from './models/risk-register.model';
import { FinalReviewRatingModel } from './models/final-review-rating.model';
import { ProjectStatusModel } from './models/project-status.model';
import { ToastrService } from 'ngx-toastr';
import { DatePipe, NumberFormatStyle } from '@angular/common';
import { AssigneeDetailModel } from './models/assignee-detail.model';
import { CategoryReviewerModel } from './models/category-reviewer.model';
import { CategoryViewModel } from './models/category.viewmodel';
import { AuditdetailsserviceService } from '../creation/auditor-details/auditdetailsservice.service';
import { ProjectPointofContactModel } from './models/project-poc.model';
import { QuestionsService } from 'src/app/services/Audit/questions-table.service';
import { QuestionTableConstant } from '../questions-table/question-table.constant';
import { QuestionModel, QuestionViewModel } from './models/question.model';
import { audit } from 'rxjs/operators';
import { QuestionResponseModel } from './models/question-response.model';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { error } from 'console';
import { CommentsDialogComponent } from 'src/app/components/comments-dialog/comments-dialog.component';
import { SubmitDialogComponent } from './submit-dialog/submit-dialog.component';


@Component({
  selector: 'app-project-overview',
  templateUrl: './project-overview.component.html',
  styleUrls: ['./project-overview.component.css']
})
export class ProjectOverviewComponent implements OnInit {
  private _CONSTATNTS: ProjectDetailConstant;
  private _QUESCONSTANTS: QuestionTableConstant;
  selectedProjectStatusId: any;
  selectedProjectStatusDescription: string;
  @Input() categoryId: number;

  public createdDate: string;
  public endDate: string;
  auditCategories: CategoryModel[];
  categoryInfo: CategoryModel;
  tableData: any[];
  questionTableResponseData: Array<QuestionResponseModel> = [];
  stage: string = '';
  responseDropDownOptions: any = [];
  questionSaveErrorMessage: string = '';
  ratingId: number = 0;
  hideSubmitButton: boolean = false;
  isCommentDisabled: boolean = false;
  reviewSaveErrorMessage: string = '';
  stageReviewDetailsforAccordion: StageReviewDetail;
  stageReviewDetailsMap: { [key: string]: StageReviewDetail } = {};
  reviewratingforAccodrion: { [key: number]: any } = {};
  accordionData: { [key: string]: any } = {};
  reviewCommentforAccordion: string = '';
  reviewRatingforAccordion: number = 0;
  isratingSubmitted: boolean = false;
  // isSaveButtonEnabled: boolean = false;


  constructor(private router: Router, private route: ActivatedRoute
    , private dialog: MatDialog
    , private auditOverviewService: AuditOverviewService
    , private formBuilder: FormBuilder
    , private auditSharedService: AuditSharedService
    , private toasterService: ToastrService
    , private datePipe: DatePipe
    , private auditDetailService: AuditdetailsserviceService
    , private questionService: QuestionsService) {
    this._CONSTATNTS = new ProjectDetailConstant();
  }


  auditId: number = 0;
  auditorId: number = 0;
  updatedProjectStatusId: number = 0;

  finalReviewRatingId: number = 0;
  projectDetails: any = {};
  // projectStatusModel: ProjectStatusModel = null;

  middlewareDetails: StageReviewDetail;
  databaseDetails: StageReviewDetail;
  securityDetails: StageReviewDetail;
  stageReviewDetails: Array<StageReviewDetail> = [];
  CategoryViewModels: Array<CategoryViewModel> = [];

  categoriesReviewers: Array<CategoryReviewerModel> = [];
  categoryModels: Array<CategoryModel> = [];
  responeOtions: Array<any> = [];
  componenOptions: Array<any> = [];
  subCagegoryModels: Array<SubCategoryModel> = [];
  subCategoryModelGroups: Array<SubCategoryModelGroup> = [];
  assigneeNames = [];
  assigneesDetail: Array<ProjectPointofContactModel> = [];
  assigneeName: string;
  currentDate: Date = new Date(Date.now());
  reviewComment: string = '';
  reviewStatus: number = 0;
  reviewRating: number = 0;
  isAssigneePopupVisible: boolean = false;
  finalReviewRating: FinalReviewRatingModel;

  middlewareBtn: boolean = false;
  securityBtn: boolean = false;
  databaseBtn: boolean = false;
  middlewareAssignee: string;
  databaseAssignee: string;
  securityAssignee: string;
  clickedStage: string;
  clickedStageId: number;
  clickedStageAssigneeId: number = 0;
  disableCommentsAndRatings: boolean = false;
  isAuditSummarayVisible: boolean = true;
  isRiskRegisterVisible: boolean = true;
  isFinalCommentDisabled: boolean = false;
  auditSummaryCard: CardTypes = CardTypes.AuditSummary;
  riskRegisterCard: CardTypes = CardTypes.RiskRegister;
  auditSummaryFormModelArray: Array<AuditSummaryFormModel> = [];
  riskRegisterFormModelArray: Array<RiskRegisterFormModel> = [];
  auditSummarySaveMessage: string = '';
  riskRegusterSaveMessage: string = '';
  finalReviewSubmitMessage: string = '';
  isError: boolean = true;
  selectedStatusId: number | null = null;

  lastToastResponse: any = null;
  isManagerLoggedIn: boolean = false;
  isAuditorLoggedIn: boolean = false;
  private hasErrors: boolean = false;

  loggedInEmployeeId: number;
  disablingCommentsAndRatingStage9Auditor: boolean = true;


  public get CategoryNames(): typeof CategoryNames { return CategoryNames; }
  public get CardTypes(): typeof CardTypes { return CardTypes; }


  ngOnInit() {
    this.loggedInEmployeeId = parseInt(localStorage.getItem("Id"));
    this.getAuditId();
    this.getAuditorId();
    this.auditOverviewService.selectedStatusId$.subscribe(statusId => {
      this.selectedStatusId = statusId;
    });
    this.route.url.subscribe(urlSegments => {
      const url = urlSegments.join('/');
      const pattern = /Home\/Audit\/Audit%20Overview;auditId=\d+;categoryId=\d+/;

      if (pattern.test(url)) {
        this.route.params.subscribe(params => {
          this.auditId = +params['auditId'];
          this.categoryId = +params['categoryId'];
        });
      }
    });
    // this.getCategoryReviewer(this.auditId, this.categoryId); // not needed
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        window.scrollTo(0, 0);
      }
    });
    this.auditSummaryFormModelArray.push(new AuditSummaryFormModel());
    this.riskRegisterFormModelArray.push(new RiskRegisterFormModel());
    this.getAuditDetailsByAuditId(this.auditId); //calling final review rating in this if stage > 8 
    this.getResponseDropDown();
    this.getComponentDropDown();
  }

  ngOnDestroy() {
    this.auditId_DestroyState();
    this.auditorId_DestroyState();
  }

  AreCommentsAndRatingsEnable() {
    let role = localStorage.getItem('role')
    let auditorId = localStorage.getItem('AuditorId')
    let employeeId = localStorage.getItem('Id')

    if (role != null && auditorId != null && employeeId != null) {
      console.log("emplye Id",employeeId);
      console.log("sub Auditor Id", this.categoryInfo.subAuditiorUserId);
      this.disableCommentsAndRatings = !((parseInt(employeeId) == this.categoryInfo.subAuditiorUserId) && (this.selectedProjectStatusId == 8));
    }
  }
  getAuditorId = () => {
    this.auditOverviewService.getAuditorId().subscribe((_auditorId: number) => this.auditorId = _auditorId);
    this.auditorId_MaintainState();
  }


  disableFinalCommentsSection(comments: string) {
    this.reviewComment = comments;
    this.isFinalCommentDisabled = true;
  }

  auditorId_MaintainState = () => {
    if (this.auditorId > 0) {
      localStorage.setItem('AuditorId', this.auditorId?.toString());
    }

    if (this.auditorId < 1) {
      const id = parseInt(localStorage.getItem('AuditorId'));
      this.auditorId = (!isNaN(id)) ? id : this.auditorId;
    }
  }
  auditorId_DestroyState = () => {
    localStorage.removeItem('AuditorId');
  }
  getAuditId = () => {
    this.auditSharedService.getAuditId().subscribe((_auditId: number) => this.auditId = _auditId);
    this.auditId_MaintainState();
  }


  auditId_MaintainState = () => {
    if (this.auditId > 0) {
      localStorage.setItem('AuditId', this.auditId?.toString());
    }

    if (this.auditId < 1) {
      const id = parseInt(localStorage.getItem('AuditId'));
      this.auditId = (!isNaN(id)) ? id : this.auditId;
    }
  }
  // openSubmitDialog(): void {
  //   const dialogRef = this.dialog.open(SubmitDialogComponent, {
  //     width: '350px',
  //   });
  // }
  auditId_DestroyState = () => {
    localStorage.removeItem('AuditId');
  }

  toggleIsAccordionOpen(vm: CategoryViewModel) {
    vm.isAccordionOpen = !vm.isAccordionOpen;
  }

  navigateToQuestionTable(vm: any) {
    this.toggleIsAccordionOpen(vm);
    if (vm.isAccordionOpen) {
      this.auditSharedService.setAuditId(this.auditId);
      this.auditOverviewService.setSelectedStatusId(this.selectedProjectStatusId);
      this.stage = vm.categoryModel.categoryName;
      this.getQeustionsTableData(vm.categoryModel.categoryName, this.auditId);
      this.getResponseDropdownItems();
      this.getStageReviewDetailsforAccordion(vm.categoryModel.categoryName);
    }
    // vm.isAccordionOpen = !vm.isAccordionOpen;
  }

  navigateToProjectListing() {
    this.router.navigate(['/Home/Audit']);
  }


  toggleVisibility(type: CardTypes) {
    switch (type) {
      case CardTypes.AuditSummary:
        this.isAuditSummarayVisible = !this.isAuditSummarayVisible;
        break;

      case CardTypes.RiskRegister:
        this.isRiskRegisterVisible = !this.isRiskRegisterVisible;
        break;
    }
  }

  // toggleAccordion(categoryId: number) {
  //   const itemIndex = this.CategoryViewModels?.findIndex(item => item.categoryModel.id == categoryId);
  //   if (itemIndex > -1) {
  //     const isVisible = this.CategoryViewModels[itemIndex].isQuestionTableVisible;
  //     this.CategoryViewModels[itemIndex].isQuestionTableVisible = !isVisible;
  //   }
  // }

  openPopup(stageName: string) {
    this.isAssigneePopupVisible = true;
    this.clickedStage = stageName.toLowerCase();
    this.clickedStageId = this.categoryModels?.filter(x => x.categoryName?.toLocaleLowerCase() == stageName?.toLocaleLowerCase())[0].id;
  }

  closePopup() {
    this.isAssigneePopupVisible = false;
    this.clickedStageId = 0;
    this.clickedStageAssigneeId = 0;
    this.resetAssigneeButtonState();

  }

  resetAssigneeButtonState() {
    this.clickedStageId = 0;
    this.clickedStageAssigneeId = 0;

    if (this.clickedStage == CategoryNames.Middleware) {
      this.middlewareBtn = true;
      this.middlewareAssignee = null;
    }
    else if (this.clickedStage == CategoryNames.Security) {
      this.securityBtn = true;
      this.securityAssignee = null;
    }
    else if (this.clickedStage == CategoryNames.Database) {
      this.databaseBtn = true;
      this.databaseAssignee = null
    }
  }

  selectAssigneeName(assigneeModel: AssigneeDetailModel, event: any) {
    this.clickedStageAssigneeId = (assigneeModel?.userId > 0) ? assigneeModel?.userId : 0;

    for (let i = 0; i < event.target.parentElement.children.length; i++) {
      event.target.parentElement.children[i].classList.remove('selected');
    }
    event.target.classList.add('selected');

    if (this.clickedStage == CategoryNames.Middleware) {
      this.middlewareBtn = false;
      this.middlewareAssignee = assigneeModel?.userName;
    }
    else if (this.clickedStage == CategoryNames.Security) {
      this.securityBtn = false;
      this.securityAssignee = assigneeModel?.userName;
    }
    else if (this.clickedStage == CategoryNames.Database) {
      this.databaseBtn = false;
      this.databaseAssignee = assigneeModel?.userName;
    }
  }

  hasMatchingCategory(name: string) {
    switch (name?.toLowerCase()) {
      case CategoryNames.Middleware: return true;
      case CategoryNames.Database: return true;
      case CategoryNames.Security: return true;
      default: return false;
    }
  }

  addDynamicFormControls(type: CardTypes) {
    if (type === CardTypes.AuditSummary) {
      this.auditSummaryFormModelArray.push(new AuditSummaryFormModel())
    }
    if (type === CardTypes.RiskRegister) {
      this.riskRegisterFormModelArray.push(new RiskRegisterFormModel());
    }
  }
  getStageReviewDetails() {
    this.auditOverviewService.getStageReviewDetails(this.auditId)
      .subscribe(
        (response: Array<StageReviewDetail>) => {
          this.stageReviewDetails = response;
          this.fillCategoriesReviewDetails(response);
          this.middlewareDetails = response.filter(stage => stage.categoryName.toLocaleLowerCase() == 'middleware')[0];
          this.databaseDetails = response.filter(stage => stage.categoryName.toLocaleLowerCase() == 'database')[0];
          this.securityDetails = response.filter(stage => stage.categoryName.toLocaleLowerCase() == 'security')[0];
        },
        (error) => { console.log(`${this._CONSTATNTS.GET_STAGES_REVIEW_DETAIL_API_ERROR}: `, error); }
      );
  }
  getStageReviewDetailsforAccordion(categoryDescription: string) {
    this.auditOverviewService.getStageReviewDetails(this.auditId).subscribe(
      (response: Array<StageReviewDetail>) => {
        this.reviewCommentforAccordion = '';
        this.reviewRatingforAccordion = 0;
        this.stageReviewDetailsforAccordion = response.filter(stage => stage.categoryName.toLocaleLowerCase() == categoryDescription?.toLowerCase())[0];
        if (this.stageReviewDetailsforAccordion) {
          this.isratingSubmitted = true;
          this.stageReviewDetailsMap[categoryDescription] = this.stageReviewDetailsforAccordion;
          this.reviewCommentforAccordion = (this.stageReviewDetailsMap[categoryDescription]?.comment) ? this.stageReviewDetailsMap[categoryDescription]?.comment : '';
          this.reviewRatingforAccordion = (this.stageReviewDetailsMap[categoryDescription]?.rating) ? this.stageReviewDetailsMap[categoryDescription]?.rating : 0;
          if (this.reviewComment) {
            this.disableCommentsSection(this.reviewComment)
          }
          const category_name = this.stage.toLocaleLowerCase();
          const categoryRating_id = ((category_name == 'middleware') ? 1 : (category_name == 'database') ? 2 : (category_name == 'security') ? 3 : -1);
          this.ratingId = categoryRating_id;
          this.hideSubmitButton = this.reviewRating > 0 && this.reviewComment.trim() !== '';
        }
      },
      (error) => { console.log(`${this._CONSTATNTS.GET_STAGES_REVIEW_DETAIL_API_ERROR}: `, error); }
    );
  }

  disableCommentsSection(comments: string) {
    this.reviewComment = comments;
    this.isCommentDisabled = true; //not using any where
  }

  getAssigneesName() {
    this.auditOverviewService.GetAssignees(this.auditId).subscribe(
      (responseData: Array<AssigneeDetailModel>) => {
        if (responseData?.length > 0) {
          this.assigneesDetail = responseData;
        }
      },
      (error) => { console.log(`${this._CONSTATNTS.GET_ASSIGNEES_API_ERROR}: `, error); }
    );
  }

  getAuditDetailsByAuditId(auditId: number) {
    this.auditDetailService.getAuditInfoByAuditId(auditId).subscribe(
      (response: any) => {
        const projectId = response?.projectId;
        this.selectedProjectStatusId = response?.statusId;
        this.selectedProjectStatusDescription = response?.statusName;
        this.isManagerLoggedIn = parseInt(localStorage.getItem("Id")) == response?.managerId;
        this.isAuditorLoggedIn = parseInt(localStorage.getItem("Id")) == response?.auditiorUserId;
        this.disablingCommentsAndRatingStage9Auditor = !(this.isAuditorLoggedIn && this.selectedProjectStatusId == 9);
        const categories = response?.categoryDetails;
        if (categories?.length > 0) {
          this.categoryModels = categories;
          this.AssignCategoryViewModel(categories);
          this.bindAvailableAssigneeName();
          this.getStageReviewDetails();
          this.bindCategoryQuestionsTable();
        }
        if (projectId > 0) {
          this.getProjectPointofContacts(projectId);
        }
        else {
        }
        if (this.selectedProjectStatusId > 8) {
          this.getFinalReviewRating();
          this.getRiskregister();
          this.getAuditSummary();
        }

      });
  }
  getProjectPointofContacts(projectId: number) {
    this.auditDetailService.getPointofContactName(projectId)
      .subscribe((responseData: Array<ProjectPointofContactModel>) => {
        this.assigneesDetail = responseData;
      })
  }

  createRange(count: number) {
    return Array(count).fill(0).map((x, i) => i + 1);
  }


  getSubategoryDropDown(categoryId: number, rowIndex: number) {
    this.auditOverviewService.getSubCategoryDropDown(categoryId).subscribe(
      (response: SubCategoryModel[]) => {
        if (response) {
          this.subCagegoryModels = response;

          if (!this.subCategoryModelGroups) {
            this.subCategoryModelGroups = [];
          }

          const isExists = (this.subCategoryModelGroups.filter(x => x.rowId == rowIndex)?.length > 0);
          if (isExists) {
            if (this.subCategoryModelGroups?.filter(x => x.rowId == rowIndex)?.length > 0) {
              const filterElement = this.subCategoryModelGroups?.filter(x => x.rowId == rowIndex)[0];
              const removeIndex = this.subCategoryModelGroups.indexOf(filterElement);
              this.subCategoryModelGroups.splice(removeIndex, 1);
            }

          }

          const subcategoryListForRow = new SubCategoryModelGroup();
          subcategoryListForRow.rowId = rowIndex;
          subcategoryListForRow.subCategoryModel = response;
          this.subCategoryModelGroups.push(subcategoryListForRow);
          this.subCategoryModelGroups = this.subCategoryModelGroups.sort((a, b) => a.rowId - b.rowId);
        }
      },
      (error) => { console.log(`${this._CONSTATNTS.GET_SUBCATEGORY_DROPDOWN_API_ERROR}: `, error); }
    )
  }

  getResponseDropDown() {
    this.auditOverviewService.getResponseDropDown().subscribe(
      (response) => {
        if (response instanceof Array) {
          this.responeOtions = response;
        }
      },
      (error) => { console.log(`${this._CONSTATNTS.GET_RESPONSE_DROPDOWN_API_ERROR}: `, error); }
    )
  }

  getComponentDropDown() {
    this.componenOptions = this.auditOverviewService.getComponentDropDown();
  }

  getFinalReviewRating() {
    this.auditOverviewService.getFinalReviewRating(this.auditId).subscribe(
      (response: FinalReviewRatingModel[]) => {
        if (response && response?.length > 0) {
          this.finalReviewRating = response[0];
          this.endDate = this.finalReviewRating.endDate;
          this.reviewComment = (this.finalReviewRating) ? this.finalReviewRating?.comments : '';
          if (this.reviewComment) {
            this.disableFinalCommentsSection(this.reviewComment)
          }
          this.finalReviewRatingId = this.finalReviewRating?.id ?? -1;
          // this.projectStatusModel.id = this.finalReviewRating.status;

        }
      },
      (error) => {
        console.log(this._CONSTATNTS.GET_FINAL_REVIEW_RATING_API_ERROR, error);
      }
    );
  }

  getProjectStatus() {
    this.auditOverviewService.getProjectStatus(this.auditId).subscribe(
      (responseData: ProjectStatusModel) => {
        // this.projectStatusModel = responseData;
        this.selectedProjectStatusId = responseData.statusId;
        this.selectedProjectStatusDescription = responseData.description;
      },
      (error) => {
        console.log(this._CONSTATNTS.GET_PROJECT_STATUS_API_ERROR, error);
      }
    );
  }

  filterDetailByStageName(data: StageReviewDetail[], stageName: string): StageReviewDetail {
    const filterResult = data.filter(stage => {
      stage.categoryName.toLocaleLowerCase() == stageName?.toLocaleLowerCase()
    });

    if (filterResult.length > 0) {
      return filterResult[0];
    }
  }

  onCategorySelectionChanged(categoryId: string, rowIndex: number) {
    this.subCagegoryModels = [];
    if (parseInt(categoryId) > 0) {
      this.getSubategoryDropDown(parseInt(categoryId), rowIndex);
    }
  }

  ratingChangeHandler(event): void {

    if (!this.disableCommentsAndRatings) {
      this.reviewRating = parseInt(event.target.value);
    }

  }

  removeRow(event, modelArray: any[]) {
    const rowIndex = parseInt(event.target.dataset.rowindex);
    modelArray.splice(rowIndex, 1);
    this.removeSubcategoryModelDataForRowIndex(rowIndex);
  }

  removeSubcategoryModelDataForRowIndex(rowIndex: number) {
    const filterElement = this.subCategoryModelGroups?.filter(x => x.rowId == rowIndex)[0];
    const removeIndex = this.subCategoryModelGroups.indexOf(filterElement);
    this.subCategoryModelGroups.splice(removeIndex, 1);
    for (let index = 0; index < this.subCategoryModelGroups?.length; index++) {
      this.subCategoryModelGroups[index].rowId = index;
    }
  }

  getCategoryReviewer(auditId: number, categoryId: number) {

    const createdOn = this.questionService.getCreatedOn(auditId, categoryId);

    if (createdOn) {
      this.setCategoryStartDate(categoryId, createdOn);
      this.auditOverviewService.getCategoryReviewerDetail(auditId, categoryId).subscribe(
        (response: CategoryReviewerModel) => {
          if (response?.reviewerId > 0) {
            this.makeAssignedAssigneeSelected(categoryId, response.reviewerId);
          }
        },
        (error) => {
          console.error(this._CONSTATNTS.GET_CATEGORY_REVIEWER_API_ERROR, error);
          this.makeAssignedAssigneeSelected(categoryId, -1);
        }
      );
    } else {
      this.auditOverviewService.getCategoryReviewerDetail(auditId, categoryId).subscribe(
        (responseData: CategoryReviewerModel) => {
          if (responseData?.reviewerId > 0) {
            this.categoriesReviewers.push(responseData);
            this.setDiscrepancyRaisedAndIsSubmitted(responseData.isSubmitted, responseData.discrepancyRaised, categoryId)
            this.makeAssignedAssigneeSelected(categoryId, responseData.reviewerId);
            this.setCategoryStartDate(categoryId, responseData.startDate);
          }
        },
        (error) => {
          console.error(this._CONSTATNTS.GET_CATEGORY_REVIEWER_API_ERROR, error);
          this.makeAssignedAssigneeSelected(categoryId, -1);
        }
      );
    }
  }

  setDiscrepancyRaisedAndIsSubmitted(isSubmitted: boolean, discrepancyRaised: boolean, categoryId: number) {
    const itemIndex: number = this.CategoryViewModels?.findIndex(x => x.categoryModel?.categoryId == categoryId);
    if (itemIndex >= 0) {
      this.CategoryViewModels[itemIndex].isSubmitted = isSubmitted;
      this.CategoryViewModels[itemIndex].discrepancyRaised = discrepancyRaised;
    }
  }

  makeAssignedAssigneeSelected(categoryId: number, assigneeUserId: number) {
    const itemIndex: number = this.CategoryViewModels?.findIndex(x => x.categoryModel?.categoryId == categoryId);
    if (itemIndex >= 0 && assigneeUserId > 0) {
      this.CategoryViewModels[itemIndex].selectedAssigneeId = assigneeUserId;
    }

  }

  setCategoryStartDate(categoryId: number, startDate: string) {
    const itemIndex: number = this.CategoryViewModels?.findIndex(x => x.categoryModel?.categoryId == categoryId);
    if (itemIndex >= 0) {
      this.CategoryViewModels[itemIndex].startDate = startDate;
    }
  }

  bindAvailableAssigneeName() {
    if (this.categoryModels?.length > 0) {
      for (let index = 0; index < this.categoryModels.length; index++) {
        const categegoryId = this.categoryModels[index].categoryId;
        this.getCategoryReviewer(this.auditId, categegoryId);
      }
    }
  }

  getSaveRiskRegisterAPIPaylod(): any[] {
    let requestData: any[] = [];
    const modelArray = this.riskRegisterFormModelArray;
    if (modelArray?.length > 0) {
      const currentUserId = parseInt(localStorage.getItem('Id'));

      modelArray.forEach(model => {
        if (model) {
          const categoryId: number = model.categoryId;
          const componentId: number = model.componentId;
          if (categoryId > 0 && componentId > 0) {
            const data = {
              id: (model.id > 0) ? model.id : 0,
              auditId: this.auditId,
              categoryId: isNaN(categoryId) ? 0 : categoryId,
              componentId: isNaN(componentId) ? 0 : componentId,
              risk: model.risk,
              mitigationPlan: model.mitigationPlan,
              registeredBy: model.registeredBy,
              status: model.status,
              closerDate: new Date(model.closerDate).toISOString(),
              comments: model.comments,
              isActive: true,
              createdBy: currentUserId,
              createdOn: this.currentDate.toISOString(),
              modifyBy: currentUserId,
              modifyOn: this.currentDate.toISOString(),
              isNew: true
            };
            requestData.push(data);
          }
          else {
            requestData = [];
            this.toasterService.error('Risk Register: Please fill the form data!');
            return requestData;
          }
        }
      });

      return requestData;
    }
  }

  getSaveAuditSummaryAPIPaylod(): any[] {
    let requestData: any[] = [];
    if (this.auditSummaryFormModelArray?.length > 0) {
      const currentUserId = parseInt(localStorage.getItem('Id'));

      this.auditSummaryFormModelArray.forEach(model => {
        const categoryId: number = parseInt(model.categoryId?.toString());
        const subCategoryId: number = parseInt(model.categorySubCategoryId?.toString());
        const dbLayerResponseId: number = parseInt(model.middleAndDbLayerRating?.toString());
        const uiLayerResponseId: number = parseInt(model.uiLayerRating.toString());
        if (categoryId > 0 && dbLayerResponseId > 0 && uiLayerResponseId > 0) {
          const data = {
            id: model.id,
            auditId: this.auditId,
            categoryId: isNaN(categoryId) ? 0 : categoryId,
            weightage: model.weightage,
            uiLayerRating: isNaN(uiLayerResponseId) ? 0 : uiLayerResponseId,
            middleAndDbLayerRating: isNaN(dbLayerResponseId) ? 0 : dbLayerResponseId,
            comments: model.comments,
            isActive: true,
            createdBy: currentUserId,
            createdOn: this.currentDate.toISOString(),
            modifyBy: currentUserId,
            modifyOn: this.currentDate.toISOString(),

          };
          requestData.push(data);
        }
        else {
          requestData = [];
          this.toasterService.error('Audit Summary: Please fill the form data!');
          return requestData;
        }
      });
      return requestData;
    }
  }

  saveFinalReview() {
    if (this.finalReviewRatingId > 0) {
      this.toasterService.info("Review already submitted earlier");
      return;
    }

    const loginUserId = parseInt(localStorage.getItem('Id'));
    const data: any = {
      id: this.finalReviewRatingId,
      auditId: this.auditId,
      rating: this.reviewRating,
      comments: this.reviewComment,
      status: 3,
      isActive: true,
      createdBy: loginUserId,
      createdOn: this.currentDate.toISOString(),
      modifyBy: loginUserId,
      modifyOn: this.currentDate.toISOString(),
    };
    const errorMessages = [
      { condition: data?.rating < 1, message: 'Please provide a rating.' },
      { condition: data?.comments === "", message: 'Please add comments.' },
    ];
    for (const { condition, message } of errorMessages) {
      if (condition) {
        this.toasterService.error(message);
        return;
      }
    }
    this.auditOverviewService.saveFinalReview(data).subscribe(
      (response) => {
        this.isError = false;
        this.finalReviewSubmitMessage = this._CONSTATNTS.AUDDIT_FINAL_REVIEW_SUBMIT_SUCCESS;
        if (this.finalReviewRatingId > 0) {
          this.finalReviewSubmitMessage = this.finalReviewSubmitMessage.replace('submitted', 'updated');
        }
        this.toasterService.success(this.finalReviewSubmitMessage);
        this.router.navigate(['/Home/Audit']);
      },
      (error) => {
        this.isError = true;
        this.finalReviewSubmitMessage = this._CONSTATNTS.AUDDIT_FINAL_REVIEW_SUBMIT_ERROR;
        this.toasterService.error(this.finalReviewSubmitMessage);
      }
    );

  }

  saveAuditSummary() {
    const requestData: any[] = this.getSaveAuditSummaryAPIPaylod();
    if (requestData?.length > 0) {
      this.auditOverviewService.saveAuditSummary(requestData).subscribe(
        (response) => {
          this.isError = false;
          this.auditSummaryFormModelArray = this.auditSummaryFormModelArray.filter(x => x.categoryId > 0);
          this.toasterService.success(this._CONSTATNTS.AUDIT_SUMMARY_SAVE_SUCCESS);
        },
        (error) => {
          this.isError = true;
          this.toasterService.error(this._CONSTATNTS.AUDIT_SUMMARY_SAVE_ERROR);
          console.log(`${this._CONSTATNTS.AUDIT_SUMMARY_SAVE_ERROR}:`, error);
        }
      );
    }
  }

  saveRiskRegister() {
    const requestData: any[] = this.getSaveRiskRegisterAPIPaylod();
    if (requestData.length > 0) {
      this.auditOverviewService.saveRiskRegister(requestData).subscribe(
        (response) => {
          this.isError = false;
          this.riskRegisterFormModelArray.splice(0, this.riskRegisterFormModelArray.length);
          this.getRiskregister()
          this.toasterService.success(this._CONSTATNTS.RISK_REGISTER_SAVED_SUCCESS);
          console.log(`${this._CONSTATNTS.RISK_REGISTER_SAVED_SUCCESS}: `, response);
        },
        (error) => {
          this.isError = true;
          this.toasterService.error(this._CONSTATNTS.RISK_REGISTER_SAVE_ERROR);
          console.log(`${this._CONSTATNTS.RISK_REGISTER_SAVE_ERROR}: `, error);
        }
      );
    }
  }

  storeRiskRegister: any;
  getRiskregister() {
    this.auditOverviewService.getRiskregister(this.auditId).subscribe(
      (response: Array<RiskRegisterFormModel>) => {
        this.riskRegisterFormModelArray = [];
        this.storeRiskRegister = response;
        this.storeRiskRegister.forEach(receivedItem => {
          const newForm = new RiskRegisterFormModel();
          newForm.id = receivedItem.id;
          newForm.categoryId = receivedItem.categoryId;
          newForm.closerDate = receivedItem.closerDate?.split('T')[0];
          newForm.comments = receivedItem.comments;
          newForm.componentId = receivedItem.componentId;
          newForm.mitigationPlan = receivedItem.mitigationPlan;
          newForm.registeredBy = receivedItem.registeredBy;
          newForm.risk = receivedItem.risk;
          newForm.status = receivedItem.status;
          newForm.isNew = false;

          this.riskRegisterFormModelArray.push(newForm);
        });

        if (this.riskRegisterFormModelArray?.length == 0) {
          this.riskRegisterFormModelArray.push(new RiskRegisterFormModel());
        }
      }
    )

  }

  getAuditSummary() {
    this.auditOverviewService.getAuditSummary(this.auditId).subscribe(
      (responseData: Array<AuditSummaryFormModel>) => {
        this.auditSummaryFormModelArray = [];
        responseData.forEach((item, index) => {
          const model = new AuditSummaryFormModel();
          model.id = item.id;
          model.categoryId = item.categoryId;
          model.categorySubCategoryId = item.categorySubCategoryId;
          model.uiLayerRating = item.uiLayerRating;
          model.middleAndDbLayerRating = item.uiLayerRating;
          model.weightage = item.weightage;
          model.comments = item.comments;
          this.auditSummaryFormModelArray.push(model);
          this.getSubategoryDropDown(item.categoryId, index);
        });

        if (this.auditSummaryFormModelArray?.length == 0) {
          this.auditSummaryFormModelArray.push(new AuditSummaryFormModel());
        }
      }
    )
  }

  bindCategoryQuestionsTable() {
    if (this.categoryModels?.length > 0) {
      for (let index = 0; index < this.categoryModels.length; index++) {
        const categegoryId = this.categoryModels[index]?.categoryId;
        this.questionService?.getQuestions(categegoryId).subscribe(
          (responseData: Array<QuestionModel>) => {
            const defaultSelectedValue: number = -1;
            let questionVM: Array<QuestionViewModel> = responseData.map((data) => ({
              ...data, comment: ''
              , auditorComment: ''
              , selectedResponseOption: defaultSelectedValue
            }));
            if (questionVM?.length > 0) {
              const itemIndex = this.categoryModels.findIndex(x => x.categoryId == categegoryId);
              if (itemIndex > -1) {
                this.CategoryViewModels[itemIndex].questionsViewModel = questionVM;
              }
            }
          },
          (error) => {
            console.log(`_QUESCONSTANTS.GET_QUESTION_TABLE_DATA_API_ERROR:`, error);
          });
      }
    }
  }

  sendNotificationMail() {
    this.isError = true;
    this.toasterService.error('As of now, this feature is not available!');
  }

  saveCategoryAssignee() {

    if (this.isSaveAssigneeRequestDataValid() == false) {
      return;
    }

    const data = {
      id: 0,
      auditId: this.auditId,
      categoryId: this.clickedStageId,
      reviewerId: this.clickedStageAssigneeId,
      startDate: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
      endDate: null
    }
    this.auditOverviewService.saveCategoryAssignee(data).subscribe(
      (responseData: any) => {
        this.isAssigneePopupVisible = false;
        this.clickedStageId = 0;
        this.clickedStageAssigneeId = 0;

        this.toasterService.success('Assignee assigned successfully!');
        this.bindAvailableAssigneeName();
        this.getProjectStatus();
      },
      (error) => {
        this.toasterService.error(this._CONSTATNTS.SAVE_ASSIGNEE_API_ERROR, error);
      }
    );
  }

  // onAssigneeSelected() {
  //   this.isSaveButtonEnabled = true;
  // }

  saveButtonClicked(showSuccessToaster?: boolean) {
    showSuccessToaster = showSuccessToaster ?? true;
    let requestdata: any[] = [];
    for (let index = 0; index < this.categoryModels.length; index++) {
      const dataItem = {
        auditId: this.auditId,
        categoryId: this.CategoryViewModels[index].categoryModel.categoryId,
        reviewerId: this.CategoryViewModels[index].selectedAssigneeId,
        startDate: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
      };
      requestdata.push(dataItem);
    }
    this.auditOverviewService.SaveCategoryReviewersDetails(requestdata).subscribe(
      (response) => {
        // this.isSaveButtonEnabled = false;
        if (showSuccessToaster) {
          this.toasterService.success('Assignee saved successfully!');
        }
      },
      (error) => {
        this.toasterService.error(this._CONSTATNTS.SAVE_ASSIGNEE_API_ERROR, error);
      }
    );
  }

  saveSelectedAssignee($event: any, stageName: string) {
    const filteredCategoryModel = this.categoryModels?.filter(x => x.categoryName?.toLocaleLowerCase() == stageName?.toLocaleLowerCase());
    this.clickedStageId = (filteredCategoryModel?.length > 0) ? filteredCategoryModel[0].categoryId : 0;
    this.clickedStageAssigneeId = ($event.target.value) ? parseInt($event.target.value) : 0;

    if (this.isSaveAssigneeRequestDataValid() == false) {
      return;
    }

    const data = {
      id: 0,
      auditId: this.auditId,
      categoryId: this.clickedStageId,
      reviewerId: this.clickedStageAssigneeId,
      startDate: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'),
      endDate: null
    }

    this.auditOverviewService.saveCategoryAssignee(data).subscribe(
      (responseData: any) => {
        this.clickedStageId = 0;
        this.clickedStageAssigneeId = 0;
        this.toasterService.success('Assignee assigned successfully!');
        this.setCategoryStartDate(data.categoryId, data.startDate);
        this.getProjectStatus();
      },
      (error) => {
        this.toasterService.error(this._CONSTATNTS.SAVE_ASSIGNEE_API_ERROR, error);
      }
    );
  }

  isSaveAssigneeRequestDataValid() {
    if (this.clickedStageAssigneeId < 1 || this.clickedStageId < 1 || this.auditId < 1) {

      if (this.clickedStageAssigneeId < 1) {
        this.toasterService.error('Please select an assignee name!');
      }
      else if (this.clickedStageId < 1 || this.auditId < 1) {
        this.toasterService.error('Please contact to admin IT');
      }
      return false;
    }
    return true;
  }

  fillCategoriesReviewDetails(categoryReviewDetails: Array<StageReviewDetail>) {
    try {
      this.categoryModels.forEach(x => {
        const filteredStageReviewDetails: Array<StageReviewDetail> = categoryReviewDetails?.filter(item => item.categoryName?.toLocaleLowerCase() == x.categoryName?.toLocaleLowerCase());
        if (filteredStageReviewDetails?.length > 0) {
          x.auditCategoryReview = filteredStageReviewDetails;
        }
      });

      if (this.CategoryViewModels?.length > 0) {
        this.CategoryViewModels.forEach(x => {
          const filteredStageReviewDetails: Array<StageReviewDetail> = categoryReviewDetails?.filter(item => item.categoryName?.toLocaleLowerCase() == x.categoryModel.categoryName?.toLocaleLowerCase());
          if (filteredStageReviewDetails?.length > 0) {
            x.categoryModel.auditCategoryReview = filteredStageReviewDetails;
          }
        });
      }
    }
    catch (e) { }
  }

  AssignCategoryViewModel(models: Array<CategoryModel>) {
    models?.forEach((model, index) => {
      const categoryViewModel = new CategoryViewModel();
      categoryViewModel.categoryModel = model;
      categoryViewModel.isAccordionOpen = false;
      this.CategoryViewModels.push(categoryViewModel);
    });
  }

  isAuditSummaryFormValid() {

  }
  getQeustionsTableData(categoryDescription: string, auditId: number) {
    this.auditDetailService.getAuditInfoByAuditId(auditId).subscribe(
      (responseData: any) => {
        this.auditCategories = responseData?.categoryDetails;
        this.categoryInfo = this.auditCategories.filter(x => x.categoryName?.toLocaleLowerCase() == categoryDescription.toLocaleLowerCase())[0];
        this.categoryId = this.categoryInfo.categoryId;
        this.AreCommentsAndRatingsEnable();
      },
      (error) => {
        console.log(error);
      },
      (complee: void) => {
        (this.categoryId > 0) && this.questionService.getQuestions(this.categoryId).subscribe(
          (responseData) => {
            this.accordionData[categoryDescription] = responseData.map((data) => ({
              ...data, comment: ''
              , auditorComment: ''
              , selectedResponseOption: 0
              , supportingMaterial: 0
            }));
            console.log("response", this.accordionData[categoryDescription]);
          },
          (error) => {
            console.log(`${this._CONSTATNTS.GET_QUESTION_TABLE_DATA_API_ERROR}:`, error);
          },
          (complete: void) => {
            this.getQuestionTableResponse(this.categoryId);
          });

        if (this.categoryId > 0 && this.auditId) {
          this.getCategoryReviewer(this.auditId, this.categoryId);
        }
      }
    );
  }
  getQuestionTableResponse(categoryId: number) {
    this.questionService.getQuestionsResponse(this.auditId, categoryId).subscribe(
      (responseData: Array<QuestionResponseModel>) => {
        this.questionTableResponseData = responseData;
        const categoryDescription = this.auditCategories.find(x => x.categoryId === categoryId)?.categoryName;
        if (categoryDescription) {
          this.accordionData[categoryDescription] = this.accordionData[categoryDescription].map((data, index) => ({
            ...data,
            ...this.questionTableResponseData[index],
            selectedResponseOption: this.responseDropDownOptions.find(x => x.description?.toLocaleLowerCase() == this.questionTableResponseData[index]?.response?.toLocaleLowerCase())?.id || 0,
            supportingMaterial: this.questionTableResponseData[index]?.isSupportingMaterialVerified
              ? (this.questionTableResponseData[index].isSupportingMaterialVerified.toString().toLowerCase() === "true" ? 1 : 0)
              : 0,
            comment: this.questionTableResponseData[index]?.observationExceptionsReasons || '',
            auditorComment: this.questionTableResponseData[index]?.auditorRecommedation || '',
          }));
        }
        this.bindSavedQuestionResponseInUI(categoryId);
      },
      (error) => {
        console.log(this._CONSTATNTS.GET_QUESTION_RESPONSE_API_ERROR, error);
      },
    );
  }

  bindSavedQuestionResponseInUI(categoryId) {
    const categoryDescription = this.auditCategories.find(x => x.id === categoryId)?.categoryName;
    const tableData = this.accordionData[categoryDescription];
    if (tableData?.length > 0 && this.questionTableResponseData?.length > 0) {
      const questionCount = tableData.length;
      const responseCount = this.questionTableResponseData.length;

      if (questionCount > responseCount) {
        this.toasterService.error('Question and Question response count is different.');
        return;
      }

      for (let i = 0; i < tableData?.length; i++) {
        const responseText = this.questionTableResponseData[i]?.response;
        const savedResponseId = this.responseDropDownOptions.filter(x => x.description?.toLocaleLowerCase() == responseText?.toLocaleLowerCase())[0].id
        tableData[i].selectedResponseOption = savedResponseId;
        let isSupportingMaterialVerified: any = this.questionTableResponseData[i].isSupportingMaterialVerified;

        if (typeof isSupportingMaterialVerified === 'string') {
          isSupportingMaterialVerified = isSupportingMaterialVerified.toLowerCase() === "true";
        } else if (isSupportingMaterialVerified === null || isSupportingMaterialVerified === undefined) {
          isSupportingMaterialVerified = 0;
        }
        tableData[i].supportingMaterial = isSupportingMaterialVerified;
        tableData[i].comment = this.questionTableResponseData[i].observationExceptionsReasons;
        tableData[i].auditorComment = this.questionTableResponseData[i].auditorRecommedation;
      }
    }
  }
  resetQuestionTable(categoryDescription: string) {
    if (this.accordionData[categoryDescription]?.length > 0) {
      for (let i = 0; i < this.accordionData[categoryDescription]?.length; i++) {
        this.accordionData[categoryDescription][i].selectedResponseOption = 0;
        this.accordionData[categoryDescription][i].supportingMaterial = 0;
        this.accordionData[categoryDescription][i].comment = '';
        this.accordionData[categoryDescription][i].auditorComment = '';
      }
    }
    const categoryInfo = this.auditCategories.filter(x => x.categoryName?.toLocaleLowerCase() == categoryDescription.toLocaleLowerCase())[0];
    const categoryId = categoryInfo.categoryId;
    this.questionService.ClearCategoryResponse(categoryId, this.auditId).subscribe(
      (responseData) => {
        this.responseDropDownOptions = responseData;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  combinedSubmitFunctionality(categoryViewModel: CategoryViewModel) {
    if(categoryViewModel.discrepancyRaised) {
      this.clarificationNeededForCategoryButtonClicked(categoryViewModel);
    } else {
      this.submitSubAuditorComments(categoryViewModel.categoryModel, false, false); //false because else
    }
  }

  submitSubAuditorComments(categoryDescription: any, discrepancyRaised: boolean, isRatingValidationNeeded: boolean = true) {
    this.saveSubAuditorComments(categoryDescription.categoryName);
    const result = this.validationsForSubmitCategory(categoryDescription, categoryDescription.categoryName, isRatingValidationNeeded);
    if (!result) {
      return
    }
    this.submitCategoryReview(categoryDescription, categoryDescription.categoryName);
    const requestData = {
      auditId: this.auditId,
      categoryId: categoryDescription.categoryId,
      discrepancyRaised: discrepancyRaised,
    };
    this.questionService.submitCategoryBySubAuditor(requestData).subscribe(
      (response) => {
        //refresh the page
        window.location.reload();
        // this.getProjectStatus();
        this.toasterService.success("Successfully submitted the data");
      },
      (error) => {
        this.toasterService.error(`error saving data, ${error}`);
      }
    );
  }

  saveSubAuditorComments(categoryDescription: any) {
    let questionComment = [];
    this.accordionData[categoryDescription].forEach(o => {
      let data = {
        questionId: o.questionId,
        subAuditorComment: o.auditorComment
      };
      questionComment.push(data);
    });
    const requestData = {
      auditId: this.auditId,
      questions: questionComment
    };
    this.questionService.saveSubAuditorCommentsForQuestionId(requestData).subscribe(
      (response) => {
        this.toasterService.success("Successfully saved the data");
      },
      (error) => {
        this.toasterService.error(`error saving data, ${error}`);
      });
  }

  saveQuestionTableResponseData(categoryDescription: any) {
    let requestData = [];
    //No need to map this(currentUserId) to request data front end backend can have this access
    const currentUserId = parseInt(localStorage.getItem('Id'));
    const categoryInfo = this.auditCategories.filter(x => x.categoryName?.toLocaleLowerCase() == categoryDescription.toLocaleLowerCase())[0];
    const categoryId = categoryInfo.categoryId;
    this.accordionData[categoryDescription].forEach(o => {
      let data = {
        id: 0,
        auditId: this.auditId,
        categoryId: categoryId,
        questionId: o.questionId,
        responseId: parseInt(o.selectedResponseOption),
        isSupportingMaterialVerified: (o.supportingMaterial == 1) ? true : false,
        observationExceptionsReasons: o.comment,
        isActive: this.categoryInfo.isActive ? this.categoryInfo.isActive : true,
        createdBy: currentUserId,
        createdOn: this.currentDate.toISOString(),
        modifyBy: currentUserId,
        modifyOn: this.currentDate.toISOString()
      };
      requestData.push(data);
    });
    this.questionService.saveQuestionsResponse(requestData).subscribe(
      (response) => {
        this.toasterService.success(this._CONSTATNTS.QEUSTION_RESPONSE_SAVE_SUCCESS);
        this.questionSaveErrorMessage = this._CONSTATNTS.QEUSTION_RESPONSE_SAVE_SUCCESS;
      },
      (error) => {
        this.questionSaveErrorMessage = this._CONSTATNTS.QEUSTION_RESPONSE_SAVE_ERROR;
        this.toasterService.error(this.questionSaveErrorMessage);
      });

  }
  //can write save functionality and submit functioanlity as written for submitSubAuditorComments.
  submitQuestionTableResponseData(categoryDescription: any) {
    let requestData = [];
    const currentUserId = parseInt(localStorage.getItem('Id'));
    const categoryInfo = this.auditCategories.filter(x => x.categoryName?.toLocaleLowerCase() == categoryDescription.toLocaleLowerCase())[0];
    const categoryId = categoryInfo.categoryId;
    this.accordionData[categoryDescription].forEach(o => {
      let data = {
        id: 0,
        auditId: this.auditId,
        categoryId: categoryId,
        questionId: o.questionId,
        responseId: parseInt(o.selectedResponseOption),
        isSupportingMaterialVerified: (o.supportingMaterial == 1) ? true : false,
        observationExceptionsReasons: o.comment,
        isActive: this.categoryInfo.isActive ? this.categoryInfo.isActive : true,
        createdBy: currentUserId,
        createdOn: this.currentDate.toISOString(),
        modifyBy: currentUserId,
        modifyOn: this.currentDate.toISOString()
      };
      requestData.push(data);
    });
    // const dialogRef = this.dialog.open(SubmitDialogComponent, {
    //   width: '350px',
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   if (result) {
        let validationError = this.getQuestionFormValidationError(requestData);
        if (validationError?.length > 0) {
          this.toasterService.error(validationError);
          validationError = "";
          return;
        }

        this.questionService.saveQuestionsResponse(requestData).subscribe(
          (response) => {
            this.toasterService.success(this._CONSTATNTS.QEUSTION_RESPONSE_SUBMIT_SUCCESS);
            this.questionSaveErrorMessage = this._CONSTATNTS.QEUSTION_RESPONSE_SUBMIT_SUCCESS;
          },
          (error) => {
            this.questionSaveErrorMessage = this._CONSTATNTS.QEUSTION_RESPONSE_SUBMIT_ERROR;
            this.toasterService.error(this.questionSaveErrorMessage);
          });
        this.questionService.SubmitCategory(this.auditId, categoryId).subscribe(
          (response) => {
            console.log("success");
            window.location.reload();
            // this.getProjectStatus();
          },
          (error) => {
            console.log(error);
          }
        )
      // }
    // });
  }
  getQuestionFormValidationError(requestData: Array<any>): string {
    let validationErrors: string = "";
    // if (requestData.some(x => x.responseId === 0) || (requestData.some(x => !x.observationExceptionsReasons || x.observationExceptionsReasons.length === 0))) {
    //   validationErrors = "Please fill all the details."
    // }
    if (requestData.some(x => x.responseId === 0)) {
      validationErrors = 'Please select a valid response';
    }
    else if (requestData.some(x => !x.observationExceptionsReasons || x.observationExceptionsReasons.length === 0)) {
      validationErrors += `${validationErrors.length > 0 ? ', ' : ''}Please add comment`;
    }
    // else if (requestData.some(x => x.isSupportingMaterialVerified === 0)) {
    //   validationErrors += `${validationErrors.length > 0 ? ', ' : ''}Please verify supporting material`;
    // }
    return validationErrors;
  }


  getResponseDropdownItems() {
    this.questionService.getAuditResponseDropDown().subscribe(
      (responseData) => {
        this.responseDropDownOptions = responseData;
      },
      (error) => {
        console.log(`${this._CONSTATNTS.GET_RESPONSE_DROPDOWN_API_ERROR}: `, error);
      }
    );
  }
  validationsForSubmitCategory(category: any,categoryDescription: string, isRatingValidationNeeded: boolean): boolean {
    if (this.ratingId > 0) {
      this.toasterService.info("Review already submitted earlier");
      return false;
    }
    const currentUserId = parseInt(localStorage.getItem('Id'));
    let requestData = {
      id: this.ratingId,
      auditId: this.auditId,
      categoryId: category.categoryId,
      isActive: (this.categoryInfo) ? this.categoryInfo.isActive : false,
      rating: this.stageReviewDetailsMap[categoryDescription]?.rating,
      comments: this.stageReviewDetailsMap[categoryDescription]?.comment,
      categoryReviewerId: currentUserId,
      createdBy: currentUserId,
      createdOn: this.currentDate.toISOString(),
      modifyBy: currentUserId,
      modifyOn: this.currentDate.toISOString(),
    };

    if ((!requestData.rating || requestData?.rating < 1) && isRatingValidationNeeded) {
      this.toasterService.error('Rating is Required for submit.Please provide a rating.');
      return false;
    }
    if (!requestData.comments || requestData.comments.trim() === '') {
      this.toasterService.error('Please add comments.');
      return false;
    }
    this.disableCommentsSection(requestData.comments);
    return true
  }

  submitCategoryReview(category: any,categoryDescription: string) {
    let requestData = {
      id: this.ratingId,
      auditId: this.auditId,
      categoryId: category.categoryId,
      isActive: (this.categoryInfo) ? this.categoryInfo.isActive : false,
      rating: this.stageReviewDetailsMap[categoryDescription]?.rating,
      comments: this.stageReviewDetailsMap[categoryDescription]?.comment,
      categoryReviewerId: this.loggedInEmployeeId,
      createdBy: this.loggedInEmployeeId,
      createdOn: this.currentDate.toISOString(),
      modifyBy: this.loggedInEmployeeId,
      modifyOn: this.currentDate.toISOString(),
    };
    this.questionService.saveCategoryReview(requestData).subscribe(
      (response) => {
        this.isError = false;
        this.toasterService.success(this._CONSTATNTS.CATEGORY_REVIEW_SUBMIT_SUCCESS);
        this.auditSharedService.setAuditId(this.auditId); // Make auditId available for project-overview page
        this.questionService.setCreatedOn(this.auditId, this.categoryId, requestData.createdOn); // Store createdOn date        
        this.auditOverviewService.getCategoryReviewerDetail(this.auditId, this.categoryId);
        // this.isratingSubmitted = true;
        // setTimeout(() => {
        //   this.router.navigate(['Home/Audit/Audit Overview', { auditId: this.auditId, categoryId: this.categoryId }]);
        // }, 0);
        return true;
      },
      (error) => {
        this.isError = true;
        this.reviewSaveErrorMessage = this._CONSTATNTS.CATEGORY_REVIEW_SUBMIT_ERROR;
        this.toasterService.error(this.reviewSaveErrorMessage);
      }
    );
  }
  ratingChangeHandlerforAccordion(event, categoryDescription: string): void {
    if (!this.stageReviewDetailsMap[categoryDescription]) {
      this.stageReviewDetailsMap[categoryDescription] = {
        categoryName: '',
        rating: 0,
        categoryReviewerName: '',
        comment: '',
        startDate: '',
        endDate: ''
      };
    }
    this.stageReviewDetailsMap[categoryDescription].rating = parseInt(event.target.value);
    console.log(this.stageReviewDetailsMap[categoryDescription]?.rating);
  }

  getCommentForAccordion(categoryDescription: string): string {
    return this.stageReviewDetailsMap[categoryDescription]?.comment || '';
  }

  setCommentForAccordion(categoryDescription: string, comment: string): void {
    if (!this.stageReviewDetailsMap[categoryDescription]) {
      this.stageReviewDetailsMap[categoryDescription].comment = '';
    }
    this.stageReviewDetailsMap[categoryDescription].comment = comment;
  }

  validationsToSubmitFinalReview() {
    this.hasErrors = false;
    // Audit Summary Validations
    this.hasErrors = this.hasErrors || 
      this.auditSummaryFormModelArray?.some(item => !item.categoryId || item.categoryId === -1 || 
        !item.weightage || !item.uiLayerRating || item.uiLayerRating === -1 || !item.middleAndDbLayerRating || 
        item.middleAndDbLayerRating === -1
      );
    // Risk Register Validations
    this.hasErrors = this.hasErrors || 
      this.riskRegisterFormModelArray?.some(item => !item.categoryId || item.categoryId === -1 || 
        !item.componentId || item.componentId === -1 || !item.risk || !item.comments || 
        !item.closerDate || !item.registeredBy || !item.mitigationPlan || !item.status    // Add other checks for mitigationPlan, registeredBy, etc.
      );
    // Final Review Validations
    this.hasErrors = this.hasErrors || !this.reviewComment;
      // (this.reviewRating === undefined || this.reviewRating === 0 || !this.reviewComment);
    return this.hasErrors;
  }

  submitButtonClicked() {
    if (this.selectedProjectStatusId == 5) {
      // if (this.isSaveButtonEnabled) {
      //   this.saveButtonClicked(false);
      // }
      for (let index = 0; index < this.CategoryViewModels.length; index++) {
        const dataItem = {
          auditId: this.auditId,
          categoryId: this.CategoryViewModels[index].categoryModel.categoryId,
          reviewerId: this.CategoryViewModels[index].selectedAssigneeId,
        };
        if (this.CategoryViewModels[index].selectedAssigneeId == 0) {
          this.toasterService.error(`Please add a reviewer for categrory ${this.CategoryViewModels[index].categoryModel.categoryName}`);
          return;
        }
      }
      this.saveButtonClicked(false);
      this.auditOverviewService.saveAuditStatus(this.auditId, 6).subscribe(
        (response) => {
          this.toasterService.success("Successfully submitted the reviewers");
          this.getProjectStatus();
          console.log(response);
        },
        (error) => {
          this.toasterService.error("Error in submitting, Please try again.");
          console.log(error);
        }
      );
    }
    else if (this.selectedProjectStatusId == 9 && this.isAuditorLoggedIn) {
      // Validations
      if (this.validationsToSubmitFinalReview()) {
        this.toasterService.error("Please fill in the mandatory fields.");
        return
      }
      else {
        //save the details
        this.saveAuditSummary();
        this.saveRiskRegister();
        this.saveFinalReview();
        //change the stage
        this.auditOverviewService.saveAuditStatus(this.auditId, 10).subscribe(
          (response) => {
            this.toasterService.success("Successfully submitted the reviewers");
            this.getProjectStatus();
            console.log(response);
          },
          (error) => {
            this.toasterService.error("Error in submitting, Please try again.");
            console.log(error);
          }
        );
      }
    }
  }

  clarificationNeededForCategoryButtonClicked(category: CategoryViewModel) {
    const comment = this.stageReviewDetailsMap[category.categoryModel.categoryName]?.comment;
    
    if (comment == null || comment == "") {
      this.toasterService.error("Please enter sub auditor comments to raise discrepancy.");
      return
    }
    this.auditOverviewService.clarificationNeededForAuditIdandCategoryId(
      this.auditId,
      this.selectedProjectStatusId,
      category.categoryModel.categoryId,
      comment.trim()
    ).subscribe(
      (response) => {
        this.toasterService.success("Successfully raised a discrepancy.");
        // this.getProjectStatus(); // is this really needed here.
      },
      (error) => {
        this.toasterService.error("Error in raising discrepancy, Please try again.");
        console.log(error);
      }
    );
    this.submitSubAuditorComments(category.categoryModel, true, false);
    // this.dialog.open(CommentsDialogComponent)
    //   .afterClosed()
    //   .subscribe((response) => {
    //     if (response) {
    //       this.auditOverviewService.clarificationNeededForAuditIdandCategoryId(
    //         this.auditId,
    //         this.selectedProjectStatusId,
    //         category.categoryModel.categoryId,
    //         response.trim()
    //       ).subscribe(
    //         (response) => {
    //           this.toasterService.success("Successfully raised a discrepancy.");
    //           this.getProjectStatus(); // is this really needed here.
    //         },
    //         (error) => {
    //           this.toasterService.error("Error in raising discrepancy, Please try again.");
    //           console.log(error);
    //         }
    //       );
    //     }
    //   });
  }

  ManagersubmitButtonClicked() {
    if (this.selectedProjectStatusId == 7) {
      this.auditOverviewService.saveAuditStatus(this.auditId, 8).subscribe(
        (response) => {
          this.toasterService.success("Successfully submitted the reviewers");
          this.getProjectStatus();
          console.log(response);
        },
        (error) => {
          this.toasterService.error("Error in submitting, Please try again.");
          console.log(error);
        }
      );
    }
  }

  clarificationNeededButtonClickedByAuditor() {
    if (this.selectedProjectStatusId == 9 && this.isAuditorLoggedIn == true) {
      this.dialog.open(CommentsDialogComponent)
      .afterClosed()
      .subscribe((response) => {
        if (response) {
          this.auditOverviewService.saveAuditStatus(this.auditId, 5, response.trim()).subscribe(
            (response) => {
              this.toasterService.success("Successfully raised a discrepancy.");
              this.getProjectStatus();
            },
            (error) => {
              this.toasterService.error("Error in raising discrepancy, Please try again.");
              console.log(error);
            }
          );
        }
      });
    }
  }

  getDropdownTooltip(selectedOption: number): string {
    if (selectedOption > 0 && this.responseDropDownOptions) {
      const selectedResponse = this.responseDropDownOptions.find(x => x.id === selectedOption);
      return selectedResponse ? selectedResponse.description : 'Select Response';
    } else {
      return 'Select Response';
    }
  }

}